// Module
var code = "<div class=\"structure-string-input structure-value-input\" v-if=\"definition && definition.type === 'String'\"> <structure-value-name :name=\"name\" :description=\"definition.description\"/> <div class=\"string-input\"> <input type=\"text\" :value=\"value\" @input=\"inputChanged\"> </div> </div> ";
// Exports
module.exports = code;